import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-100",
  src: "media/images/dashboard.png",
  alt: "",
  title: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_type = _resolveComponent("user-type")!

  return (_openBlock(), _createBlock(_component_user_type, { type: 0 }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}